import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils/link_helper';
import type {FaqArticleLink} from 'app/utils/knowledgeCenter/faqGrouping';

interface Props {
    articles: FaqArticleLink[]
}

const KnowledgeCenterPopularArticles = ({articles}: Props): React.ReactElement | null => {
    if (articles.length === 0) {
        return null;
    }

    return (
        <section className="knowledge-center__popular">
            <h2 className="knowledge-center__section-title">{I18n.t('knowledge_center.popular_articles')}</h2>
            <div className="knowledge-center__chips">
                {articles.map((article: FaqArticleLink) => <Link
                    key={article.name}
                    to={getLinkPath(`/faq/${article.name}`)}
                    className="knowledge-center__chip"
                >
                    {article.title}
                </Link>)}
            </div>
        </section>
    );
};

export default KnowledgeCenterPopularArticles;
